export default __webpack_public_path__ + "static/media/original_with_white-cutout.1e31114c.png";